/* evr-erstanalyse.js
 * State-Machine für den Erstanalyse-Funnel (Neuer Flow mit Ausschluss-Gate).
 * Reihenfolge (6 Fragen + 2 Zwischenscreens):
 *   1) Schmerzbereiche (multi)  -> Frage 1/6
 *   2) Intensität je Region      -> Frage 2/6
 *   *) Zwischenscreen Testimonial (je stärkster Region)
 *   3) Fuß-Diagnosen (multi)     -> Frage 3/6
 *   4) Eignungs-Gate (multi)     -> Frage 4/6   (Treffer -> Abklärungs-/Kontakt-Pfad)
 *   5) Bisher versucht (multi + Freitext) -> Frage 5/6
 *   *) Zwischenscreen Aha-Moment (je Antwort)
 *   6) Versicherung (single)     -> Frage 6/6   (GKV -> Krankenkassen-Box einblenden)
 *   -> Verarbeitung -> Ergebnis A (Video/Hilfe) oder B (Kontakt/Abklärung)
 *
 * - Pro Section-Instanz gescoped, Theme-Editor-sicher (mehrfach mountbar).
 * - Lead-Daten vorerst nur client-seitig: window.EVR.erstanalyse + dataLayer-Hook.
 * - Anonyme Funnel-Statistik + Kauf-Attribution wie zuvor (nur Aggregat-Zähler).
 */
(function () {
  "use strict";

  var TOTAL_Q = 7;

  // Ablauf: jeder Eintrag ist ein Panel. `q` = Fragenzähler (nur bei echten Fragen).
  var FLOW = [
    { panel: "regions",     q: 1, cheer: "Los geht’s!" },
    { panel: "intensity",   q: 2, cheer: "Weiter so!" },
    { panel: "testimonial", label: "Echte Erfahrung", cta: "Weiter" },
    { panel: "feet",        q: 3, cheer: "Läuft – bald geschafft!" },
    { panel: "gate",        q: 4, cheer: "Fast geschafft!" },
    { panel: "tried",       q: 5, cheer: "Nur noch ein paar Schritte!" },
    { panel: "aha",         label: "Gut zu wissen", cta: "Verstanden" },
    { panel: "exercises",   q: 6, cheer: "Fast geschafft!" },
    { panel: "insurance",   q: 7, cheer: "Letzte Frage!" }
  ];

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function regionToResult(label) {
    if (!label) return "Schmerzen";
    if (/schmerz|beschwerden/i.test(label)) return label;
    return label + "schmerzen";
  }

  function mount(rootOrId) {
    var root = typeof rootOrId === "string" ? document.getElementById(rootOrId) : rootOrId;
    if (!root || root.__eaMounted) return;
    root.__eaMounted = true;

    var state = {
      regions: [],          // geordnete Region-Keys (Reihenfolge der Auswahl)
      intensities: {},      // key -> 1..10
      feet: [],             // Fuß-Diagnosen (Labels)
      feetFree: "",         // Freitext "Etwas anderes" bei den Fuß-Diagnosen
      gate: [],             // Gate-Auswahl (Labels)
      disq: false,          // Treffer im Gate -> Kontakt-/Abklärungs-Pfad
      tried: [],            // bisher versucht (Labels)
      triedFree: "",        // Freitext "Etwas anderes"
      ahaKey: null,         // welcher Aha-Text gezeigt wird
      exercises: null,      // 'ja' | 'vielleicht' | 'nein' (Interesse an Übungen)
      insurance: null,      // 'gkv' | 'pkv'
      kkInsurer: "",        // gewählte gesetzliche Kasse (nur für CTA-Redirect)
      primaryRegion: null
    };
    var pos = 0;            // Zeiger in FLOW
    var eaBooted = false;
    var procTimer = null;   // Timer des Verarbeitungs-Screens (fuer Abbruch bei Zurueck)
    var instanceId = root.id || "evr-ea";

    var PAIN_MIN = 1, PAIN_MAX = 10;

    /* ---------- Screens & Chrome ---------- */
    var screens = {};
    qsa(root, "[data-screen]").forEach(function (el) { screens[el.getAttribute("data-screen")] = el; });

    var panels = {};
    qsa(root, "[data-panel]").forEach(function (el) { panels[el.getAttribute("data-panel")] = el; });

    var stepLabel   = qs(root, "[data-ea-steplabel]");
    var pbarWrap    = qs(root, "[data-ea-pbar]");
    var pfill       = qs(root, "[data-ea-pfill]");
    var cheerEl     = qs(root, "[data-ea-cheer]");
    var nextBtn     = qs(root, "[data-ea-next]");
    var nextArrow   = nextBtn ? nextBtn.querySelector(".ea-cta-label") : null;
    var zoneNote    = qs(root, "[data-ea-zonenote]");

    /* ---------- Anonyme Funnel-Statistik ---------- */
    var statsEndpoint = root.getAttribute("data-ea-stats") || "";
    var statsTest = !!(window.Shopify && window.Shopify.designMode);
    var trackedSteps = {};
    function track(name, data) {
      if (!statsEndpoint) return;
      try {
        var payload = { event: name, test: statsTest };
        if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; } }
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          navigator.sendBeacon(statsEndpoint, new Blob([body], { type: "application/json" }));
        } else {
          fetch(statsEndpoint, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: body, keepalive: true, credentials: "same-origin"
          }).catch(function () {});
        }
      } catch (e) { /* fail silent */ }
    }

    // Einstiegs-Quelle (Theme-gesetzte ID via ?ea_src=<id>) + Referrer-Host.
    // Aggregat/nicht-personenbezogen: nur die ID bzw. der Hostname des Referrers,
    // NIE die vollständige Referrer-URL (könnte Query-Parameter mit PII enthalten).
    var eaSource = "";
    var eaReferrer = "";
    try {
      eaSource = (new URLSearchParams(window.location.search).get("ea_src") || "").trim().slice(0, 60);
      var ref = document.referrer || "";
      if (ref) {
        var selfHost = window.location.hostname.replace(/^www\./, "");
        var refHost = new URL(ref).hostname.replace(/^www\./, "");
        eaReferrer = (refHost === selfHost) ? "(intern)" : refHost.slice(0, 80);
      } else {
        eaReferrer = "(direkt)";
      }
    } catch (e) { /* ignore */ }

    function eaMark(key) {
      try { localStorage.setItem(key, new Date().toISOString()); } catch (e) { /* ignore */ }
    }

    function scrollToTop() {
      if (!eaBooted) return;
      try {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
      } catch (e) {
        try { root.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e2) {}
      }
    }

    function showScreen(name) {
      Object.keys(screens).forEach(function (k) { screens[k].classList.toggle("is-active", k === name); });
      scrollToTop();
    }

    function eaEscape(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    /* ---------- Region-Helfer ---------- */
    function regionBtns() { return qsa(root, "[data-ea-region-btn]"); }
    function activeRegionBtns() { return regionBtns().filter(function (b) { return b.classList.contains("is-sel"); }); }
    function regionLabel(key) {
      var el = root.querySelector('[data-ea-region-btn][data-region-key="' + key + '"]');
      return el ? (el.getAttribute("data-region") || key) : key;
    }
    function regionResultLabel(key) {
      var el = root.querySelector('[data-ea-region-btn][data-region-key="' + key + '"]');
      return el ? (el.getAttribute("data-result-label") || el.getAttribute("data-region") || key) : key;
    }
    function orderedActiveKeys() {
      var active = activeRegionBtns().map(function (b) { return b.getAttribute("data-region-key"); });
      var ordered = [];
      state.regions.forEach(function (k) { if (active.indexOf(k) !== -1 && ordered.indexOf(k) === -1) ordered.push(k); });
      active.forEach(function (k) { if (k && ordered.indexOf(k) === -1) ordered.push(k); });
      return ordered;
    }
    function strongestRegionKey() {
      var keys = orderedActiveKeys(), best = null, bestV = -1;
      keys.forEach(function (k) {
        var v = (state.intensities && state.intensities[k] != null) ? state.intensities[k] : 0;
        if (v > bestV) { bestV = v; best = k; }
      });
      return best || (keys.length ? keys[0] : null);
    }

    /* ---------- Q1: Schmerzbereiche (multi) ---------- */
    function refreshRegions() {
      state.regions = orderedActiveKeys();
      if (zoneNote) {
        var n = state.regions.length;
        zoneNote.textContent = n
          ? (n + (n === 1 ? " Bereich" : " Bereiche") + " gewählt")
          : "";
      }
      validate();
    }
    regionBtns().forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.getAttribute("data-region-key");
        var on = !b.classList.contains("is-sel");
        b.classList.toggle("is-sel", on);
        if (on) {
          if (state.regions.indexOf(key) === -1) state.regions.push(key);
        } else {
          var idx = state.regions.indexOf(key);
          if (idx !== -1) state.regions.splice(idx, 1);
        }
        refreshRegions();
      });
    });

    /* ---------- Q2: Intensität je Region (Slider) ---------- */
    function intensityLabel(v) {
      if (v <= 1) return "Sehr leichte Schmerzen";
      if (v <= 2) return "Leichte Schmerzen";
      if (v <= 3) return "Leicht–mittlere Schmerzen";
      if (v <= 4) return "Mittlere Schmerzen";
      if (v <= 5) return "Mittelstarke Schmerzen";
      if (v <= 6) return "Mittel–starke Schmerzen";
      if (v <= 7) return "Starke Schmerzen";
      if (v <= 8) return "Sehr starke Schmerzen";
      if (v <= 9) return "Stärkste Schmerzen";
      return "Unerträgliche Schmerzen";
    }
    function buildPainSliders() {
      var list = qs(root, "[data-ea-pain-list]");
      if (!list) return;
      state.intensities = state.intensities || {};
      var keys = orderedActiveKeys();
      list.innerHTML = "";
      keys.forEach(function (k) {
        var label = regionLabel(k);
        var val = (state.intensities[k] != null) ? state.intensities[k] : 5;
        state.intensities[k] = val;
        var item = document.createElement("div");
        item.className = "ea-srow";
        item.setAttribute("data-region-key", k);
        item.innerHTML =
          '<div class="ea-slabel">' + eaEscape(label) + '</div>' +
          '<div class="ea-sval"><span class="ea-sval-num"></span> · <span class="ea-sval-txt"></span></div>' +
          '<input type="range" class="ea-slider" min="' + PAIN_MIN + '" max="' + PAIN_MAX + '" step="1" ' +
          'aria-label="Schmerzstärke ' + eaEscape(label) + '">' +
          '<div class="ea-sends"><span>leicht</span><span>unerträglich</span></div>';
        var input = item.querySelector("input");
        var num = item.querySelector(".ea-sval-num");
        var txt = item.querySelector(".ea-sval-txt");
        input.value = val;
        function sync() {
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = PAIN_MIN;
          state.intensities[k] = v;
          input.style.setProperty("--ea-pct", ((v - PAIN_MIN) / (PAIN_MAX - PAIN_MIN) * 100) + "%");
          num.textContent = v;
          txt.textContent = intensityLabel(v);
        }
        input.addEventListener("input", sync);
        sync();
        list.appendChild(item);
      });
    }

    /* ---------- Testimonial-Zwischenscreen ---------- */
    function buildTestimonial() {
      var box = qs(root, "[data-ea-testi]");
      if (!box) return;
      var key = strongestRegionKey();
      var items = qsa(box, "[data-testi]");
      var chosen = (key && qs(box, '[data-testi="' + key + '"]')) ||
        qs(box, '[data-testi="__default"]') ||
        (items.length ? items[0] : null);
      items.forEach(function (it) { it.hidden = (it !== chosen); });
    }

    /* ---------- Generisches Multi-Select (Fuß, Gate, Versucht) ---------- */
    function wireMulti(groupSel, stateKey, opts) {
      opts = opts || {};
      qsa(root, groupSel + " [data-ea-opt]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var isNone = btn.getAttribute("data-none") === "true";
          if (isNone) {
            var willSelect = !btn.classList.contains("is-sel");
            qsa(root, groupSel + " [data-ea-opt]").forEach(function (o) { o.classList.remove("is-sel"); });
            if (willSelect) btn.classList.add("is-sel");
            // Freitext-Feld leeren, wenn "keins" gewählt
            var free = qs(root, groupSel + " [data-ea-free]");
            if (free && willSelect) free.value = "";
          } else {
            btn.classList.toggle("is-sel");
            var none = qs(root, groupSel + ' [data-none="true"]');
            if (none) none.classList.remove("is-sel");
          }
          collectMulti(groupSel, stateKey, opts);
        });
      });
      var freeInput = qs(root, groupSel + " [data-ea-free]");
      if (freeInput) {
        freeInput.addEventListener("input", function () {
          // Freitext-Eingabe hebt "keins"-Auswahl auf
          if (freeInput.value.trim()) {
            var none = qs(root, groupSel + ' [data-none="true"]');
            if (none) none.classList.remove("is-sel");
          }
          collectMulti(groupSel, stateKey, opts);
        });
      }
    }
    function collectMulti(groupSel, stateKey, opts) {
      var sel = qsa(root, groupSel + " [data-ea-opt].is-sel");
      var labels = sel
        .filter(function (c) { return c.getAttribute("data-none") !== "true"; })
        .map(function (c) { return (c.getAttribute("data-label") || c.textContent).trim(); });
      state[stateKey] = labels;

      if (stateKey === "gate") {
        var disqSel = sel.filter(function (c) { return c.getAttribute("data-disq") === "true"; });
        state.disq = disqSel.length > 0;
      }
      if (stateKey === "tried") {
        var free = qs(root, groupSel + " [data-ea-free]");
        state.triedFree = free ? free.value.trim() : "";
        computeAhaKey();
      }
      if (stateKey === "feet") {
        var freeF = qs(root, groupSel + " [data-ea-free]");
        state.feetFree = freeF ? freeF.value.trim() : "";
      }
      validate();
    }

    // Welcher Aha-Text? Priorität: konkrete Ansätze vor "Nichts davon".
    function computeAhaKey() {
      var order = ["einlagen", "physio", "facharzt", "sport", "etwas-anderes", "nichts"];
      var selectedKeys = qsa(root, '[data-panel="tried"] [data-ea-opt].is-sel')
        .map(function (c) { return c.getAttribute("data-aha-key"); })
        .filter(Boolean);
      if (state.triedFree) selectedKeys.push("etwas-anderes");
      var key = null;
      for (var i = 0; i < order.length; i++) {
        if (selectedKeys.indexOf(order[i]) !== -1) { key = order[i]; break; }
      }
      state.ahaKey = key;
    }
    function buildAha() {
      var box = qs(root, "[data-ea-aha]");
      if (!box) return;
      var chosen = (state.ahaKey && qs(box, '[data-aha="' + state.ahaKey + '"]')) ||
        qs(box, '[data-aha="__default"]');
      qsa(box, "[data-aha]").forEach(function (it) { it.hidden = (it !== chosen); });
    }

    // Multi-Select-Gruppen verdrahten
    wireMulti('[data-panel="feet"]', "feet");
    wireMulti('[data-panel="gate"]', "gate");
    wireMulti('[data-panel="tried"]', "tried");

    /* ---------- Übungen-Interesse (single) ---------- */
    qsa(root, '[data-panel="exercises"] [data-ea-ex]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(root, '[data-panel="exercises"] [data-ea-ex]').forEach(function (o) { o.classList.remove("is-sel"); });
        btn.classList.add("is-sel");
        state.exercises = btn.getAttribute("data-ex");
        validate();
      });
    });

    /* ---------- Q7: Versicherung (single) + KK-/PKV-Box ---------- */
    var kkBox = qs(root, "[data-ea-kk]");   // GKV: Kassen-Auswahl
    var pkvBox = qs(root, "[data-ea-pkv]"); // PKV: Rezept-Hinweis

    // Gewählte gesetzliche Kasse merken (nur für die CTA-Weiterleitung ?insurer=…).
    // Das KK-Snippet feuert das Event auf `window` (wie evr-zpp-config.js) -> dort lauschen.
    window.addEventListener("evr:zpp:selection", function (e) {
      if (e && e.detail && e.detail.insurer) state.kkInsurer = String(e.detail.insurer);
    });

    // GKV-Kassenwahl ist an den Präventionskurs gekoppelt: ohne Übungen
    // (Frage 6 = "nein") keine §20-Erstattung -> keine Kassenwahl anzeigen.
    // Der PKV-Privatrezept-Hinweis wird dagegen IMMER (bei PKV) gezeigt –
    // private Erstattung funktioniert auch ohne Präventionskurs.
    function syncInsuranceExtras() {
      var wantsCourse = state.exercises !== "nein";
      var isGkv = state.insurance === "gkv";
      var isPkv = state.insurance === "pkv";
      if (kkBox) {
        var showKk = isGkv && wantsCourse;
        kkBox.hidden = !showKk;
        if (showKk) {
          // Krankenkassen erst bei Bedarf laden (lazy init des Controllers)
          try { document.dispatchEvent(new CustomEvent("evr:kk:init", { detail: { scope: root } })); } catch (e) {}
        }
      }
      if (pkvBox) pkvBox.hidden = !isPkv;
    }

    qsa(root, '[data-panel="insurance"] [data-ea-ins]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(root, '[data-panel="insurance"] [data-ea-ins]').forEach(function (o) { o.classList.remove("is-sel"); });
        btn.classList.add("is-sel");
        state.insurance = btn.getAttribute("data-ins");
        syncInsuranceExtras();
        validate();
      });
    });

    /* ---------- Validierung je Panel ---------- */
    function currentFlow() { return FLOW[pos]; }
    function validate() {
      var f = currentFlow();
      if (!nextBtn) return;
      var ok = true;
      switch (f.panel) {
        case "regions":   ok = state.regions.length > 0; break;
        case "intensity": ok = true; break;
        case "feet":      ok = qsa(root, '[data-panel="feet"] [data-ea-opt].is-sel').length > 0 || !!state.feetFree; break;
        case "gate":      ok = qsa(root, '[data-panel="gate"] [data-ea-opt].is-sel').length > 0; break;
        case "tried":     ok = qsa(root, '[data-panel="tried"] [data-ea-opt].is-sel').length > 0 || !!state.triedFree; break;
        case "exercises": ok = !!state.exercises; break;
        case "insurance": ok = !!state.insurance; break;
        default:          ok = true; // Zwischenscreens immer weiter
      }
      nextBtn.disabled = !ok;
    }

    /* ---------- Panel-Anzeige ---------- */
    function showPanel() {
      var f = currentFlow();
      Object.keys(panels).forEach(function (k) { panels[k].classList.toggle("is-on", k === f.panel); });

      // Chrome konfigurieren
      var isInter = !f.q;
      if (stepLabel) stepLabel.textContent = isInter ? (f.label || "") : ("Frage " + f.q + " von " + TOTAL_Q);
      if (pbarWrap) pbarWrap.style.display = isInter ? "none" : "";
      if (cheerEl)  cheerEl.style.display = isInter ? "none" : "";
      if (!isInter) {
        if (pfill)  pfill.style.width = (f.q / TOTAL_Q * 100) + "%";
        if (cheerEl) cheerEl.textContent = f.cheer || "";
      }
      if (nextArrow) nextArrow.textContent = f.cta || "Weiter";

      // Panel-spezifischer Aufbau
      if (f.panel === "intensity")   buildPainSliders();
      if (f.panel === "testimonial") buildTestimonial();
      if (f.panel === "aha")         buildAha();
      if (f.panel === "insurance")   syncInsuranceExtras(); // ggf. Kursbezug neu bewerten (z.B. nach Zurück auf Frage 6)

      validate();
      scrollToTop();

      if (eaBooted && f.q && !trackedSteps[f.q]) { trackedSteps[f.q] = true; track("step", { step: f.q }); }
    }

    /* ---------- Navigation (mit Browser-History) ---------- */
    // Jede Vorwaerts-Bewegung legt einen History-Eintrag an; Browser-Zurueck/Vor
    // (popstate) rendert den Ziel-Screen, ohne selbst zu pushen. Der interne
    // Zurueck-Pfeil ruft history.back() -> beide Wege bleiben synchron.
    function pushView(view) {
      try { history.pushState({ ea: view.ea, pos: view.pos, kind: view.kind, id: instanceId }, ""); } catch (e) {}
    }
    function prevStep() { try { history.back(); } catch (e) { showScreen("landing"); } }
    function nextStep() {
      if (pos < FLOW.length - 1) { pos++; showPanel(); pushView({ ea: "quiz", pos: pos }); return; }
      runProcessing();
    }

    // Echten Erstattungswert (Präventionskurs, §20 SGB V) für die gewählte gesetzliche
    // Kasse aus dem ZPP-Rechner holen und in die Angebots-Box schreiben.
    // Nur Anzeige (KEIN select=1 -> zählt nicht als Kassenauswahl; die KK-Box loggt das bereits).
    function fetchOfferRefund(offer, el, label, insurer) {
      try {
        var cfg = (window.EVR && window.EVR.zpp) || {};
        var base = cfg.API_BASE || "/apps/eversion-backend/api/zpp";
        var kurs = cfg.KURS_ID || "";
        if (!kurs || !insurer) return;
        var priceStr = offer.getAttribute("data-price-mit") || "";
        var digits = priceStr.match(/\d+/g);
        var preis = digits ? digits.join("") : "249"; // "249 €" -> "249"
        var params = new URLSearchParams({ preis: preis, kursId: kurs, insurer: insurer });
        fetch(base + "/refund?" + params.toString(), { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var amt = data && Number(data.amount);
            if (!amt || !isFinite(amt) || amt <= 0) return; // nur echten Wert zeigen
            var eur = new Intl.NumberFormat("de-DE", {
              style: "currency", currency: "EUR", maximumFractionDigits: 0
            }).format(amt);
            el.textContent = " · " + (label || "Krankenkasse erstattet davon") + " " + eur;
            el.hidden = false;
          })
          .catch(function () { /* still: Zeile bleibt aus */ });
      } catch (e) { /* ignore */ }
    }

    function startFlow() {
      track("start", { source: eaSource || null, referrer: eaReferrer || null });
      pos = 0; showPanel(); showScreen("quiz"); pushView({ ea: "quiz", pos: 0 });
    }
    var startBtn = qs(root, "[data-ea-start]");
    if (startBtn) startBtn.addEventListener("click", startFlow);
    var prevBtn = qs(root, "[data-ea-prev]");
    if (prevBtn) prevBtn.addEventListener("click", prevStep);
    if (nextBtn) nextBtn.addEventListener("click", nextStep);

    window.addEventListener("popstate", function (e) {
      // Laufenden Verarbeitungs-Screen abbrechen, falls man daraus zurueck geht.
      if (procTimer) { clearInterval(procTimer); procTimer = null; }
      var st = e.state;
      if (st && st.id === instanceId) {
        if (st.ea === "quiz") { pos = st.pos || 0; showScreen("quiz"); showPanel(); }
        else if (st.ea === "result") { showScreen(st.kind === "call" ? "result-call" : "result-help"); }
        else { showScreen("landing"); }
      } else {
        // fremder/leerer Zustand (= vor dem Funnel) -> zurueck auf Landing
        showScreen("landing");
      }
    });

    var ctaLink = qs(root, "[data-ea-cta-link]");
    if (ctaLink) ctaLink.addEventListener("click", function () { eaMark("evr_ea_cta_at"); track("cta"); });

    // CTA-Ziel: ohne Übungen -> 2-in-1-Produktseite (matcht die 2-in-1-Box);
    // sonst je Versicherung: GKV -> Standard-Link (3-in-1); PKV -> 2-in-1 + Param,
    // der dort die optionale Krankenkassenbox ausblendet.
    function applyHelpCtaTarget() {
      if (!ctaLink) return;
      // 3-in-1 nur mit Übungen UND gesetzlich; Privatversicherte bekommen immer 2-in-1.
      var mit = state.exercises !== "nein" && state.insurance !== "pkv";
      var gkv = ctaLink.getAttribute("data-ea-cta-gkv") || ctaLink.getAttribute("href") || "#";
      var pkv = ctaLink.getAttribute("data-ea-cta-pkv") || "";
      var ohne = ctaLink.getAttribute("data-ea-cta-ohne") || "";
      var param = ctaLink.getAttribute("data-ea-cta-pkv-param") || "";
      var append = function (url, kv) { return url + (url.indexOf("?") === -1 ? "?" : "&") + kv; };
      if (!mit && ohne) {
        // 2-in-1: PKV blendet KK-Box aus, GKV bekommt die gewählte Kasse mit.
        var uo = ohne;
        if (state.insurance === "pkv") { if (param) uo = append(uo, param); }
        else if (state.kkInsurer) { uo = append(uo, "insurer=" + encodeURIComponent(state.kkInsurer)); }
        ctaLink.setAttribute("href", uo);
      } else if (state.insurance === "pkv" && pkv) {
        ctaLink.setAttribute("href", param ? append(pkv, param) : pkv);
      } else {
        // GKV: gewählte Kasse an das Ziel übergeben, damit der Rechner sie vorwählt.
        var url = gkv;
        if (state.kkInsurer) url = append(url, "insurer=" + encodeURIComponent(state.kkInsurer));
        ctaLink.setAttribute("href", url);
      }
    }

    /* ---------- Verarbeitung ---------- */
    function runProcessing() {
      var procH = qs(root, "[data-ea-proc-heading]");
      if (procH) {
        var pk = strongestRegionKey();
        var pl = pk ? regionResultLabel(pk) : null;
        if (pl) procH.textContent = "Wir analysieren deine " + regionToResult(pl) + " …";
      }
      showScreen("processing");
      // Safari startet CSS-Animationen auf Elementen, die aus display:none sichtbar
      // werden, nicht immer neu -> Animation per Reflow hart neu anstoßen.
      // WICHTIG: gezielt den Spinner IM Processing-Screen (es gibt auch einen im Prep-Screen).
      var spin = screens["processing"] && screens["processing"].querySelector(".ea-spin");
      if (spin) { spin.style.animation = "none"; void spin.offsetWidth; spin.style.animation = ""; }
      var items = qsa(root, ".ea-loadstep");
      items.forEach(function (i) { i.classList.remove("is-done"); });
      var baseDelay = parseInt(root.getAttribute("data-ea-proc-ms"), 10);
      if (isNaN(baseDelay) || baseDelay < 200) baseDelay = 1100;
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var delay = reduce ? 220 : baseDelay;
      var i = 0;
      if (procTimer) clearInterval(procTimer);
      procTimer = setInterval(function () {
        if (i < items.length) { items[i].classList.add("is-done"); i++; }
        else { clearInterval(procTimer); procTimer = null; finish(); }
      }, delay);
    }

    /* ---------- Ergebnis ---------- */
    function publishPayload(result) {
      var payload = {
        regions: state.regions.map(function (k) { return regionLabel(k); }),
        intensities: state.intensities || {},
        feet: state.feet,
        feetFree: state.feetFree,
        gate: state.gate,
        tried: state.tried,
        triedFree: state.triedFree,
        exercises: state.exercises,
        insurance: state.insurance,
        primaryRegion: state.primaryRegion || null,
        result: result,
        ts: Date.now()
      };
      window.EVR = window.EVR || {};
      window.EVR.erstanalyse = payload;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "erstanalyse_complete", erstanalyse: payload });
      return payload;
    }

    function celebrate(scopeEl) {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var host = (scopeEl && scopeEl.querySelector(".ea-res")) || scopeEl || root;
      var box = document.createElement("div");
      box.className = "ea-confetti";
      host.appendChild(box);
      var colors = ["#0071e3", "#2883e1", "#9bbef0", "#f3b98a", "#CEE5F2"];
      for (var i = 0; i < 20; i++) {
        var p = document.createElement("i");
        p.style.cssText = "left:" + (38 + Math.random() * 24).toFixed(1) + "%;background:" + colors[i % colors.length] +
          ";--x:" + (Math.random() * 2 - 1).toFixed(2) + ";--r:" + Math.floor(Math.random() * 360) +
          "deg;animation-delay:" + Math.floor(Math.random() * 80) + "ms";
        box.appendChild(p);
      }
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1700);
    }

    function trackResult(resultType) {
      eaMark("evr_ea_reached_at");
      // Anonyme Antwort-Verteilung (Aggregat, kein Personenbezug, kein Freitext-Inhalt).
      var triedForStats = qsa(root, '[data-panel="tried"] [data-ea-opt].is-sel')
        .map(function (c) { return (c.getAttribute("data-label") || "").trim(); })
        .filter(Boolean);
      if (state.triedFree) triedForStats.push("Etwas anderes"); // nur Marker, NICHT der Freitext
      // Fuß-Diagnosen inkl. "Nichts davon" + "Etwas anderes"-Marker (analog "versucht"),
      // damit alle Optionen in der Statistik auftauchen.
      var feetForStats = qsa(root, '[data-panel="feet"] [data-ea-opt].is-sel')
        .map(function (c) { return (c.getAttribute("data-label") || "").trim(); })
        .filter(Boolean);
      if (state.feetFree) feetForStats.push("Etwas anderes"); // nur Marker, NICHT der Freitext
      // Schmerzintensität je gewählter Region (für Ø-Auswertung; Region-Key -> 1..10).
      var intensityMap = {};
      state.regions.forEach(function (k) {
        var v = state.intensities && state.intensities[k] != null ? state.intensities[k] : null;
        if (v != null) intensityMap[k] = v;
      });
      track("result", {
        result: resultType,
        regions: state.regions,          // Region-Keys (Frage 1)
        intensities: intensityMap,       // Region-Key -> Intensität 1..10 (Frage 2)
        feet: feetForStats,              // Fuß-Diagnosen inkl. "Nichts davon" (Frage 3)
        tried: triedForStats,            // Bisher versucht (Frage 5, ohne Freitext-Inhalt)
        exercises: state.exercises || null, // Übungen-Interesse (Frage 6)
        insurance: state.insurance || null, // gkv | pkv (Frage 7)
        gate_disq: state.disq            // Eignungs-Gate: Treffer? (Frage 4)
      });
    }

    function finish() {
      if (state.disq) {
        publishPayload("call");
        trackResult("call");
        pushView({ ea: "result", kind: "call" });
        showScreen("result-call");
        celebrate(screens["result-call"]);
        return;
      }
      var primKey = strongestRegionKey();
      var rlabel = primKey ? regionResultLabel(primKey) : null;
      var text = regionToResult(rlabel);
      qsa(root, ".focusRegion").forEach(function (e) { e.textContent = text; });

      var videoBox = qs(root, "[data-ea-video]");
      if (videoBox) {
        var chosen = (primKey && qs(videoBox, '[data-region-video="' + primKey + '"]')) ||
          qs(videoBox, '[data-region-video="__default"]') ||
          qs(videoBox, '[data-region-video="__placeholder"]');
        qsa(videoBox, "[data-region-video]").forEach(function (it) {
          if (it === chosen) { it.removeAttribute("hidden"); }
          else {
            it.setAttribute("hidden", "");
            var v = it.querySelector("video");
            if (v) { try { v.pause(); } catch (e) {} }
          }
        });
      }

      state.primaryRegion = primKey;
      applyHelpCtaTarget();

      // Angebots-Box je mit/ohne Übungen (Frage 6) + GKV/PKV (Frage 7) befüllen.
      var offer = qs(root, "[data-ea-offer]");
      if (offer) {
        // 3-in-1 (mit) nur bei Übungen UND gesetzlich; Privatversicherte immer 2-in-1.
        var mit = state.exercises !== "nein" && state.insurance !== "pkv";
        var d = function (n) { return offer.getAttribute("data-" + n) || ""; };
        var tEl = qs(offer, "[data-ea-offer-title]");
        var cEl = qs(offer, "[data-ea-offer-course]");
        var pEl = qs(offer, "[data-ea-offer-price]");
        var rEl = qs(offer, "[data-ea-offer-refund]");
        if (tEl) tEl.textContent = mit ? d("title-mit") : d("title-ohne");
        if (cEl) cEl.hidden = !mit; // Präventionskurs nur bei "mit Übungen"
        if (pEl) { var p = mit ? d("price-mit") : (d("price-ohne") || d("price-mit")); pEl.textContent = p; }
        // Erstattung: nur 3-in-1 (mit Übungen) + GKV + gewählte Kasse -> echten ZPP-Wert
        // nachladen; sonst nichts anzeigen (kein Platzhalter, kein PKV-Hinweis).
        if (rEl) {
          rEl.hidden = true; rEl.textContent = "";
          if (mit && state.insurance === "gkv" && state.kkInsurer) {
            fetchOfferRefund(offer, rEl, d("refund-label"), state.kkInsurer);
          }
        }
      }

      publishPayload("help");
      trackResult("help");
      pushView({ ea: "result", kind: "help" });
      showScreen("result-help");
      celebrate(screens["result-help"]);
    }

    /* ---------- Ergebnis B: Kontaktformular ---------- */
    function eaUuid() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
      return "ea-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
    }
    var form = qs(root, "[data-ea-form]");
    if (form) {
      var endpoint = form.getAttribute("data-ea-endpoint") || "/apps/eversion-backend/contact";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (form.reportValidity && !form.reportValidity()) return;

        var nameEl = form.querySelector('[name="name"]');
        var emailEl = form.querySelector('[name="email"]');
        var phoneEl = form.querySelector('[name="phone"]');
        var msgEl = form.querySelector('[name="message"]');
        var name = nameEl ? nameEl.value.trim() : "";
        var email = emailEl ? emailEl.value.trim() : "";
        var phone = phoneEl ? phoneEl.value.trim() : "";
        var message = msgEl ? msgEl.value.trim() : "";

        var regionsTxt = state.regions.length ? state.regions.map(function (k) {
          var v = state.intensities && state.intensities[k] != null ? state.intensities[k] : null;
          return regionLabel(k) + (v != null ? " (" + v + "/10)" : "");
        }).join(", ") : "–";
        var triedTxt = state.tried.slice();
        if (state.triedFree) triedTxt.push(state.triedFree);
        var feetTxt = state.feet.slice();
        if (state.feetFree) feetTxt.push(state.feetFree);
        var insuranceTxt = state.insurance === "gkv"
          ? ("Gesetzlich" + (state.kkInsurer ? " – " + state.kkInsurer : ""))
          : (state.insurance === "pkv" ? "Privat" : "–");
        var exercisesTxt = { ja: "Ja, gerne", vielleicht: "Vielleicht", nein: "Nein" }[state.exercises] || "–";
        var summaryLines = [
          "— Erstanalyse (individueller Fall) —",
          "Name: " + (name || "–"),
          "E-Mail: " + (email || "–"),
          "Telefon: " + (phone || "–"),
          "Schmerzregionen: " + regionsTxt,
          "Fuß-Diagnosen: " + (feetTxt.length ? feetTxt.join(", ") : "–"),
          "Eignungs-Gate: " + (state.gate.length ? state.gate.join(", ") : "–"),
          "Bisher versucht: " + (triedTxt.length ? triedTxt.join(", ") : "–"),
          "Interesse an Übungen: " + exercisesTxt,
          "Versicherung: " + insuranceTxt
        ];
        var fullMessage = (message ? message + "\n\n" : "") + summaryLines.join("\n");

        var payload = {
          submissionId: eaUuid(),
          formName: "erstanalyse",
          name: name,
          email: email,
          phone: phone,
          message: fullMessage,
          page: window.location.href,
          ts: new Date().toISOString()
        };

        window.EVR = window.EVR || {};
        window.EVR.erstanalyse = window.EVR.erstanalyse || {};
        window.EVR.erstanalyse.contact = { name: name, email: email, phone: phone, message: message };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "erstanalyse_lead", contact: { name: name, email: email, phone: phone, message: message } });

        var btn = form.querySelector('button[type="submit"]');
        var errorBox = qs(root, "[data-ea-form-error]");
        if (errorBox) errorBox.setAttribute("hidden", "");
        if (btn) btn.disabled = true;

        var showSuccess = function () {
          track("lead");
          var resEl = (screens["result-call"] && screens["result-call"].querySelector(".ea-res")) || form.closest(".ea-res");
          if (resEl) resEl.classList.add("ea-sent");
          form.setAttribute("hidden", "");
          var summary = qs(root, "[data-ea-success-summary]");
          if (summary) {
            summary.innerHTML =
              (name ? '<div class="ea-success-row"><span>Name</span><b>' + eaEscape(name) + '</b></div>' : '') +
              '<div class="ea-success-row"><span>E-Mail</span><b>' + eaEscape(email) + '</b></div>' +
              (phone ? '<div class="ea-success-row"><span>Telefon</span><b>' + eaEscape(phone) + '</b></div>' : '') +
              (message ? '<div class="ea-success-row ea-success-row--msg"><span>Nachricht</span><p>' + eaEscape(message) + '</p></div>' : '');
          }
          var success = qs(root, "[data-ea-form-success]");
          if (success) success.removeAttribute("hidden");
          celebrate(screens["result-call"]);
        };
        var showError = function () {
          if (btn) btn.disabled = false;
          if (errorBox) errorBox.removeAttribute("hidden");
        };

        fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload),
          credentials: "same-origin"
        }).then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          showSuccess();
        }).catch(showError);
      });
    }

    // History-Anker fuer die Landing-Ansicht, damit Zurueck aus Schritt 1 hierher
    // fuehrt (und erst der naechste Zurueck die Seite verlaesst). Nur setzen, wenn
    // noch kein eigener Zustand existiert (keinen fremden Zustand ueberschreiben).
    try { if (!history.state) history.replaceState({ ea: "landing", id: instanceId }, ""); } catch (e) {}

    // Init (ohne Anzeige)
    showPanel();
    eaBooted = true;

    // Direkt in die Fragen springen (Landing überspringen), wenn per URL angefordert
    // — z.B. Teaser-Section auf der Startseite oder Popup: CTA -> …?ea_start=1.
    // Statt hartem Screen-Wechsel kurz einen "Wir bereiten deine Analyse vor"-Loader
    // zeigen (die Klasse setzt bereits der Inline-Boot vor dem ersten Paint).
    try {
      if (new URLSearchParams(window.location.search).get("ea_start") === "1") {
        root.classList.add("ea-prepping");
        var prepMs = parseInt(root.getAttribute("data-ea-prep-ms"), 10);
        if (isNaN(prepMs) || prepMs < 0) prepMs = 900;
        var pspin = screens["prep"] && screens["prep"].querySelector(".ea-spin");
        if (pspin) { pspin.style.animation = "none"; void pspin.offsetWidth; pspin.style.animation = ""; }
        setTimeout(function () { root.classList.remove("ea-prepping"); startFlow(); }, prepMs);
      }
    } catch (e) { /* noop */ }
  }

  window.EVR_Erstanalyse = { mount: mount };

  function autoMount() { qsa(document, "[data-evr-ea]").forEach(function (el) { mount(el); }); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoMount);
  } else {
    autoMount();
  }
  try { document.dispatchEvent(new CustomEvent("evr:erstanalyse:ready")); } catch (e) { /* noop */ }
})();
